module.exports = __webpack_public_path__ + "fonts/de92dd1.woff2";